import { Injectable } from '@angular/core';
import { EnrollmentApiService } from '@features/enrollment/services/enrollment-api/enrollment-api.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Enrollment, HttpError } from '@rd/types';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import * as actions from '../actions/enrollment.actions';

@Injectable()
export class EnrollmentEffects {
  constructor(
    private actions$: Actions,
    private enrollmentApiService: EnrollmentApiService,
  ) {}

  loadEnrollments$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.EnrollmentActionTypes.LOAD_ENROLLMENTS),
      switchMap(() => {
        return this.enrollmentApiService.getEnrollments().pipe(
          map((enrollments: Enrollment[]) => {
            return new actions.LoadEnrollmentsSuccess(enrollments);
          }),
          catchError((error: HttpError) =>
            of(new actions.LoadEnrollmentsFail(error)),
          ),
        );
      }),
    ),
  );
}
